import { useTranslation } from 'react-i18next';
import TemplateModal from '../vinCode/templateModal';

/**
 * The one question before an upgrade to Complete spends credits (SC-QA-55): its price and the balance left. Every
 * caller of `POST /upgrade/:jobUuid` sends it only from this dialog's Yes.
 */
export default function UpgradeConfirmModal({ isVisible, price, currentCredits, onCancel, onConfirm }) {
    const { t } = useTranslation(['upgrade']);

    return (
        <TemplateModal
            title={t('upgrade:confirm.title')}
            content={
                <>
                    <p style={{ margin: 0 }}>{t('upgrade:confirm.message', { count: price })}</p>
                    {typeof currentCredits === 'number' && (
                        <p style={{ margin: 0 }}>{t('upgrade:confirm.remaining', { count: currentCredits - price })}</p>
                    )}
                </>
            }
            isVisible={isVisible}
            onCancel={onCancel}
            onConfirm={onConfirm}
            confirmText={t('upgrade:confirm.yes')}
            cancelText={t('upgrade:confirm.no')}
        />
    );
}
